import { RoundtableStage } from "./RoundtableStage";
import { InterruptOverlay } from "./InterruptOverlay";
import { ModeratorBar } from "../moderator/ModeratorBar";
import { useDebateStore } from "../../store/debateStore";

export function RoundtableOrchestrator() {
  // Konsey Cognitive Renaissance — Bölüm B1.
  // Sunum modunda sahne çerçevesini iyice sıyır:
  //   • inner padding `p-1 sm:p-2` → `p-0`
  //   • inner border kaldırılır (animated outer conic border zaten var)
  //   • dot-grid + noise overlay opacity yarıya iner (görsel sessizleşir)
  //   • `gap-4` → `gap-1` (ModeratorBar için sadece 4px ayırma)
  // Bu sayede sahnenin etkin alanı her kenarda ~32 px artar; üst+alt
  // toplamda ~64 px dikey kazanım — sahne neredeyse tam-bleed.
  const presentMode = useDebateStore((s) => s.presentMode);
  const wrapperGap = presentMode ? "gap-1" : "gap-4";
  const stagePadding = presentMode ? "p-0" : "p-4 sm:p-6";
  const stageBorderClass = presentMode
    ? "border-0"
    : "border border-white/[0.04]";
  const stageOverlayOpacity = presentMode ? "opacity-25" : "opacity-40";

  return (
    // Wrapper expands to fill its grid cell — critical in present mode
    // where the parent passes us a tall row and expects us to centre the
    // table inside it. `min-h-0` keeps the inner overflow honest.
    <div className={`grid h-full w-full grid-rows-[1fr_auto] ${wrapperGap}`}>
      {/* Main stage container — dramatic animated conic border + layered bg */}
      <div className="relative h-full min-h-0 rounded-3xl">
        {/* Animated conic border (outer) */}
        <div
          className="absolute -inset-[1.5px] rounded-[1.625rem] stage-conic-border opacity-60"
          aria-hidden
        />
        {/* Inner container */}
        <div
          className={
            "relative h-full overflow-hidden rounded-3xl bg-[hsl(220_22%_6%/0.95)] backdrop-blur-xl shadow-[0_4px_64px_-16px_rgb(0_0_0/0.5)] " +
            stageBorderClass
          }
        >
          {/* Dot-grid ambient pattern (behind content) */}
          <div
            className={`absolute inset-0 pointer-events-none dot-grid-pattern ${stageOverlayOpacity}`}
            aria-hidden
          />
          {/* Noise texture */}
          <div
            className="absolute inset-0 pointer-events-none mix-blend-overlay"
            style={{
              opacity: 0.025,
              backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
            }}
            aria-hidden
          />
          {/* Content — center stage vertically when the row is taller than the table */}
          <div className={`relative flex h-full items-center justify-center ${stagePadding}`}>
            <RoundtableStage />
            <InterruptOverlay />
          </div>
        </div>
      </div>
      <ModeratorBar />
    </div>
  );
}
